import type { TimelineItem as TimelineItemType } from "@tellescope/tanstack-query";
import { CallTimelineCard, ChatRoomTimelineCard, EmailTimelineCard, SMSMessageTimelineCard } from "./cards";
import { FormResponseTimelineCard } from "./cards/form_responses";

export interface TimelineItemProps {
  currentEnduserId: string;
  enduserName: string;
  item: TimelineItemType;
  className?: string;
}

export const TimelineItem = ({ item, ...rest }: TimelineItemProps) => {
  switch (item._type) {
    case "phone_call":
      return <CallTimelineCard item={item} callId={item.id} {...rest} />;
    case "form_response_group":
      return <FormResponseTimelineCard item={item} {...rest} />;
    case "sms_message":
      return <SMSMessageTimelineCard item={item} {...rest} />;
    case "chat_room":
      return <ChatRoomTimelineCard item={item} {...rest} />;
    case "email":
      return <EmailTimelineCard item={item} {...rest} />;
  }

  return null;
};
